document.addEventListener('DOMContentLoaded', function () {
    function addRemoveOption(color, location) {
        const selectList = color;
        selectList.forEach(option => {
            option.addEventListener('click', function () {
                const selected = location == 'desktop' ? document.querySelectorAll('.team-colors-gl-desktop .color-select-option.checked') : document.querySelectorAll('.team-colors-gl-mobile .color-select-option.checked');
                if (!this.classList.contains('checked') && selected.length < 3) {
                    this.classList.add('checked');
                    if (localStorage.getItem('team_colors')) {
                        const localColors = localStorage.getItem('team_colors').split(',');
                        localColors.push(option.dataset.colorName);
                        localStorage.setItem('team_colors', localColors.toString());
                    } else {
                        localStorage.setItem('team_colors', option.dataset.colorName);
                    }
                } else if (this.classList.contains('checked')) {
                    this.classList.remove('checked');
                    if (localStorage.getItem('team_colors')) {
                        const localColors = localStorage.getItem('team_colors').split(',');
                        let elementToRemove = option.dataset.colorName;
                        let index = localColors.indexOf(elementToRemove);
                        if (index > -1) {
                            localColors.splice(index, 1);
                            localStorage.setItem('team_colors', localColors);
                        }
                    }
                }
            })
        });
    }
    function applyLocalColors(colors) {
        const localColorsApply = colors;
        const localColorsApplyArray = localColorsApply.split(',');
        const bubbleTags = document.querySelectorAll('.color-list-bubble');
        bubbleTags.forEach(tag => {
            tag.style.display = 'none';
        })
        localColorsApplyArray.forEach(color => {
            const foundColors = document.querySelectorAll(`[data-color-name="${color}"]`);
            foundColors.forEach(foundColor => {
                if (foundColor.classList.contains('color-list-bubble')) {
                    foundColor.style.display = "flex"
                } else {
                    if (!foundColor.classList.contains('checked')) {
                        foundColor.classList.add('checked')
                    }
                }
            })
        })
    }
    function applyTeamColors(inputQueryString, newColorApply, colorRemove) {
        const queryString = inputQueryString;
        const urlParams = new URLSearchParams(queryString);
        let localColorsApply = localStorage.getItem('team_colors_apply');
        let localColorsApplyArray = localColorsApply.length > 0 ? localColorsApply.split(',') : localColorsApply;
        console.log(localColorsApplyArray)
        if (urlParams.has('filter.v.m.custom.sports_team_color') && !newColorApply) {
            const currentColorParams = urlParams.getAll('filter.v.m.custom.sports_team_color');
            const paramKeys = [];
            const newQuery = [];
            const colorsSearch = localColorsApplyArray;
            urlParams.forEach((value, key) => {
                paramKeys.push(key)
            });

            if (paramKeys.length > 0) {
                paramKeys.forEach(key => {
                    if (key != 'filter.v.m.custom.sports_team_color') {
                        if (urlParams.get(key).length > 0) {
                            newQuery.push(`${key}=${urlParams.get(key)}`);
                        }
                    }
                })
            }
            currentColorParams.forEach(color => {
                const colorValArray = color.split('/');
                if (!localColorsApplyArray.includes(colorValArray[colorValArray.length - 1])) {
                    colorsSearch.push(`${colorValArray[colorValArray.length - 1]}`);
                }
            })
            if (colorsSearch.length > 0) {
                colorsSearch.forEach(colorSearch => {
                    if (colorSearch != colorRemove) {
                        const colorQuery = 'gid://shopify/Metaobject/' + colorSearch;
                        newQuery.push(`filter.v.m.custom.sports_team_color=${encodeURIComponent(colorQuery)}`);
                    }
                })
            }
            const newQueryString = newQuery.join('&');

            if (window.location.href.split('?')[1] != newQueryString) {
                FacetFiltersForm.updateURLHash(newQueryString);
                FacetFiltersForm.renderSectionFromFetch(window.location.href.split('?')[0] + '?' + newQueryString);
            }

        } else {
            console.log('hello')
            const paramKeys = [];
            const newQuery = [];
            const colorsSearch = localColorsApplyArray;
            urlParams.forEach((value, key) => {
                paramKeys.push(key)
            });

            if (paramKeys.length > 0) {
                paramKeys.forEach(key => {
                    if (key != 'filter.v.m.custom.sports_team_color') {
                        if (urlParams.get(key).length > 0) {
                            newQuery.push(`${key}=${urlParams.get(key)}`);
                        }
                    }
                })
            }

            if (colorsSearch.length > 0) {
                colorsSearch.forEach(colorSearch => {
                    if (colorSearch != colorRemove) {
                        const colorQuery = 'gid://shopify/Metaobject/' + colorSearch;
                        newQuery.push(`filter.v.m.custom.sports_team_color=${encodeURIComponent(colorQuery)}`);
                    }
                })
            }
            const newQueryString = newQuery.join('&');

            if (window.location.href.split('?')[1] != newQueryString) {
                FacetFiltersForm.updateURLHash(newQueryString);
                FacetFiltersForm.renderSectionFromFetch(window.location.href.split('?')[0] + '?' + newQueryString);
            }
        }
    }
    let localColorsApply = localStorage.getItem('team_colors_apply');
    let toggle = localStorage.getItem('toggle_team_colors');
    const toggleOns = document.querySelectorAll('.team-colors-gl-toggle-on');
    const toggleOffs = document.querySelectorAll('.team-colors-gl-toggle-of');

    if (localColorsApply != null) {
        applyLocalColors(localColorsApply);
    } else {
        localStorage.setItem('team_colors_apply', '');
        localStorage.setItem('team_colors', '');
    }

    if (toggle) {
        if (toggle == 'on') {
            toggleOns[0].style.display = 'inline-block';
            toggleOffs[0].style.display = 'none';
            toggleOns[1].style.display = 'inline-block';
            toggleOffs[1].style.display = 'none';
        } else {
            toggleOns[0].style.display = 'none';
            toggleOffs[0].style.display = 'inline-block';
            toggleOns[1].style.display = 'none';
            toggleOffs[1].style.display = 'inline-block';
        }
    } else {
        localStorage.setItem('toggle_team_colors', 'off');
    }
    toggleOns.forEach(toggleOn => {
        toggleOn.addEventListener('click', function () {
            toggleOns.forEach(toggle => {
                toggle.style.display = 'none';
            })
            toggleOffs.forEach(toggle => {
                toggle.style.display = 'inline-block';
            })
            localStorage.setItem('toggle_team_colors', 'off')
        })
    })
    toggleOffs.forEach(toggleOff => {
        toggleOff.addEventListener('click', function () {
            toggleOns.forEach(toggle => {
                toggle.style.display = 'inline-block';
            })
            toggleOffs.forEach(toggle => {
                toggle.style.display = 'none';
            })
            localStorage.setItem('toggle_team_colors', 'on')
        })
    })

    const selectListDesktop = document.querySelectorAll('.team-colors-gl-desktop .color-select-option');
    const selectListMobile = document.querySelectorAll('.team-colors-gl-mobile .color-select-option');
    const applyButtons = document.querySelectorAll('.apply-btn a');

    addRemoveOption(selectListDesktop, 'desktop');
    addRemoveOption(selectListMobile, 'mobile');

    applyButtons.forEach(btn => {
        btn.addEventListener('click', function () {
            const localColors = localStorage.getItem('team_colors');
            const allColors = document.querySelectorAll('.color-select-option');

            localStorage.setItem('team_colors_apply', localColors);
            allColors.forEach(color => {
                color.classList.remove('checked');
            })
            let localColorsApply = localStorage.getItem('team_colors');
            applyLocalColors(localColorsApply);
            if (this.id == 'apply_btn') {
                document.querySelector('.team-colors-gl-desktop .team-colors-gl-select-list').style.display = 'none';
              document.querySelector('.team-colors-gl-select-list').classList.remove('is_active');
            } else {
              document.querySelector('.team-colors-gl-mobile').classList.remove('show');
              document.querySelector('.header__icon--summary').click();
            }
        })
    })

    const closeColors = document.querySelectorAll('.close-color');

    closeColors.forEach(closeColor => {
        closeColor.addEventListener('click', function () {
            const parent = this.parentElement;
            const color = parent.dataset.colorName;
            if (parent.style.display == 'flex') {
                const localColorsApply = localStorage.getItem('team_colors_apply').split(',');
                let indexApply = localColorsApply.indexOf(color);
                const localColors = localStorage.getItem('team_colors_apply').split(',');
                let index = localColors.indexOf(color);
                if (indexApply > -1) {
                    localColorsApply.splice(index, 1);
                    localStorage.setItem('team_colors_apply', localColorsApply);
                    parent.style.display = 'none';
                    document.querySelectorAll(`.color-select-option[data-color-name="${color}"]`).forEach(option => {
                        option.classList.remove('checked');
                    });
                }
                if (index > -1) {
                    localColors.splice(index, 1);
                    localStorage.setItem('team_colors', localColors);
                }
            }
        })
    })

    let localColorsApplyArray = localColorsApply.length > 0 ? localColorsApply.split(',') : localColorsApply;

    const windowLocation = window.location.href;
    if (windowLocation.includes('/collections/')) {
        if (toggle == 'on' && localColorsApplyArray != null && localColorsApplyArray.length > 0) {
            const queryString = window.location.search;
            applyTeamColors(queryString, false);
        }
        toggleOns.forEach(toggleOn => {
            toggleOn.addEventListener('click', function () {
                localStorage.setItem('toggle_team_colors', 'off')
                window.history.replaceState({}, '', window.location.href.split('?')[0]);
                FacetFiltersForm.renderSectionFromFetch(window.location.href.split('?')[0]);
            })
        })
        toggleOffs.forEach(toggleOff => {
            toggleOff.addEventListener('click', function () {
                localStorage.setItem('toggle_team_colors', 'on');
                const queryString = window.location.search;
                applyTeamColors(queryString, true);
            })
        })

        applyButtons.forEach(btn => {
            btn.addEventListener('click', function () {
                if (localStorage.getItem('toggle_team_colors') == 'on') {
                    const queryString = window.location.search;
                    applyTeamColors(queryString, true);
                }
            })
        })

        closeColors.forEach(closeColor => {
            closeColor.addEventListener('click', function () {
                if (localStorage.getItem('toggle_team_colors') == 'on') {
                    const queryString = window.location.search;
                    const parent = this.parentElement;
                    const color = parent.dataset.colorName;
                    applyTeamColors(queryString, true, color);
                }

            })
        })
    }
  document.querySelector('.team-colors-gl-desktop').addEventListener('click', function(e){
      const element = e.target;
      const classNamesToCheck  = ['team-colors-gl-select-list', 'team-colors-gl-select-title', 'color-select-option','color', 'apply-btn', 'team-colors-list', 'team-colors-gl-select-label', 'team-colors-list','btn'
      ];
      const hasAnyClass = classNamesToCheck.some(className => element.classList.contains(className));
      const colorPopup = document.querySelector('.team-colors-gl-select-list');
      if (colorPopup.style.display == 'block') {
          console.log(element);
          if(!hasAnyClass) {
              colorPopup.style.display = 'none';
              colorPopup.classList.remove('is_active');
          }
      }
      const showInfo = document.querySelector('.team-colors-gl-info-message');
      if (showInfo.classList.contains('show')) {
          if(element.classList.contains('team-colors-gl-desktop')) {
              showInfo.classList.remove('show');
          }
      }
  })
})